import React, { FC, ReactElement } from 'react';
import Tooltip from 'rc-tooltip';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import SubmitResearchButton from 'buyside/components/presentation/Button/SubmitResearchButton/submitResearchButton';

import { accessIdeasUrl, buysideSignUpUrl } from 'buyside/util/urlHelper';
import { useIsPublic } from 'buyside/util/hooks/useWindowLocation';

import { useMainNavigationCurrentUserQuery } from 'interfaces/graphql-typings';

const CTAToolTip: FC<{ children: ReactElement }> = ({ children }) => {
  const isPublic = useIsPublic();
  const { data } = useMainNavigationCurrentUserQuery({ skip: isPublic });
  const canWriteIdeas = data?.currentUser?.canWriteIdeas;

  return (
    <Tooltip
      overlay={
        <>
          <p>
            {isPublic ? (
              <>Become a member to access more content.</>
            ) : (
              <>
                Upgrade your account to unlock this section by
                {canWriteIdeas ? ' sharing your own research or ' : ' '}
                subscribing.
              </>
            )}
          </p>
          {canWriteIdeas && <SubmitResearchButton size={BUTTON_SIZES.TINIEST} />}
          {isPublic ? (
            <Button
              text="Apply Now"
              type={BUTTON_TYPES.MAJOR}
              size={BUTTON_SIZES.TINIEST}
              url={buysideSignUpUrl()}
            />
          ) : (
            <Button
              text="Upgrade"
              type={BUTTON_TYPES.MAJOR}
              size={BUTTON_SIZES.TINIEST}
              url={accessIdeasUrl()}
            />
          )}
        </>
      }
    >
      {children}
    </Tooltip>
  );
};

export default CTAToolTip;
